import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="autosubmit"
//
// Submits the form whenever one of its inputs changes. Attach to a <form> and
// wire inputs with `data-action="change->autosubmit#submit"` (change events
// bubble up from the inputs to the form element).
//
// Used to drive server-side state (e.g. candidate selection) from a checkbox:
// the form PATCHes via Turbo and the server responds with a page refresh that
// is morphed into the DOM, so no client-side state has to be reconciled.
export default class extends Controller {
  submit() {
    this.element.requestSubmit()
  }
}
